var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"loader-component"},[_c('img',{attrs:{"src":require("../../assets/loader.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }